import type { IErrorResponse } from '@/types/apis/Error';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import url from '@/statics/urls';
import api from '@/utils/api';

type UserActionType =
  | 'download_image_action'
  | 'copy_hashtag_action'
  | 'copy_caption_action'
  | 'like_action'
  | 'dislike_action';

const useUserActions = (data: {
  model_type: 'education_content' | 'content_bank';
  model_id: string;
}): UseMutationResult<any, IErrorResponse, { action: UserActionType }> =>
  useMutation({
    mutationFn: ({ action }: { action: UserActionType }) =>
      api.post<{
        model_type: 'education_content' | 'content_bank';
        model_id: string;
      }>(url.userActionLogs, { ...data, action }),
  });

export default useUserActions;
